import { GridWrapper } from "../bits/layout/Grid";
import { useTitle } from "../hooks/useTitle";
import { ManagementViewHeader } from "../patterns/ManagementViewHeader";
import { css, useTheme } from "@emotion/react";
import { Link } from "react-router";

export const ArchivedPage = () => {
  const theme = useTheme();
  useTitle("Archived Publication | Compass");

  return (
    <GridWrapper>
      <ManagementViewHeader sidePanelOpen={false} />
      <div
        css={css`
          height: 100%;
          width: 100vw;
          width: 100dvw;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 48px;
        `}
      >
        <div
          css={css`
            display: flex;
            flex-direction: column;
            align-items: center;
          `}
        >
          <h1
            style={{
              ...theme.customTypography.jumbo._1,
              color: theme.colours.primary.dark._20,
            }}
          >
            Archived Publication
          </h1>
          <h2
            style={{
              ...theme.customTypography.jumbo._3,
              color: theme.colours.primary.dark._20,
            }}
          >
            This publication is archived and cannot be accessed.
          </h2>
        </div>

        <div
          css={css`
            display: flex;
            flex-direction: column;
            align-items: center;
            ${theme.customTypography.jumbo._5}
            ${theme.colours.primary.dark._20}
          `}
        >
          <p>
            You can unarchive this publication from your
            <Link
              css={css`
                padding: 0 0 0 0.25rem;
              `}
              to="/archive"
            >
              Archive
            </Link>
            .
          </p>
        </div>
      </div>
    </GridWrapper>
  );
};
